<template>
  <div class="falcon-chart" ref="chart">

  </div>
</template>

<script>
import Chart from 'chart.js';
import {CHART_COLORS, CHART_COLORS_ARRAY, FONT_FAMILY} from "./chartColors";
import echarts from "echarts";
import {formatDollars, formatDollarsNoZeros} from "@/shared/moneyUtils";

export default {
  name: 'fundUseGraph',
  data() {
    let dataList = [
      {
        name: 'Product Development',
        value: this.data.product_development,
        itemStyle: {
          color: CHART_COLORS_ARRAY[0]
        }
      },
      {
        name: 'Sales & Marketing',
        value: this.data.sales_marketing,
        itemStyle: {
          color: CHART_COLORS_ARRAY[1]
        }
      },
      {
        name: 'Operations',
        value: this.data.operations,
        itemStyle: {
          color: CHART_COLORS_ARRAY[2]
        }
      },
      {
        name: 'Others',
        value: this.data.others,
        itemStyle: {
          color: CHART_COLORS_ARRAY[3]
        }
      },
    ];

    return {
      graphData: dataList
    }
  },
  props: ['data'],
  mounted() {

    let option = {
      tooltip: {
        trigger: 'item',
        formatter: function (params, ticket, callback) {
          return `${params.data.name}: ${formatDollarsNoZeros(params.data.value)}`;
        }
      },
      textStyle: {
        fontFamily: FONT_FAMILY
      },
      legend: {
        orient: 'vertical',
        left: 10,
        // top: 300,
        bottom: -30,
        borderRadius: [0, 0, 0, 0],
        icon: 'circle',
        padding: [0, 0, 30, 0],
        data: this.labels,
        formatter: name => {
          var series = myChart.getOption().series[0];
          var value = series.data.filter(row => row.name === name)[0].value
          return `${name} ${formatDollarsNoZeros(value)}`;
        },
      },
      series: [
        {
          top: -75,
          name: '',
          type: 'pie',
          radius: ['55%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },

          labelLine: {
            show: false
          },
          data: this.graphData,
        }
      ]
    };

    var myChart = echarts.init(this.$refs['chart'], null, {
      renderer: 'svg',
    });
    myChart.setOption(option);
  },
  methods: {},
  computed: {},
}
</script>

<style scoped>

.falcon-chart {
  background-image: url(../../../images/shareholder_chart_icon.png);
  background-repeat: no-repeat;
  background-position: 51% 37%;
  background-size: 72px;
  width: 100%;
  height: 364px;

}
</style>
